var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconError = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12.416,
  height: 12.415,
  viewBox: "0 0 12.416 12.415",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_463",
  "data-name": "Group 463",
  transform: "translate(0.4 0.4)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_206",
  "data-name": "Path 206",
  d: "M423.607,745.045a5.8,5.8,0,1,0-1.072-3.355A5.8,5.8,0,0,0,423.607,745.045Z",
  transform: "translate(-422.535 -735.882)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.8
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_207",
  "data-name": "Path 207",
  d: "M441.437,749.014a.346.346,0,0,0-.49,0l-2.393,2.392-2.393-2.393a.347.347,0,0,0-.491.49l2.393,2.393-2.393,2.393a.347.347,0,0,0,.49.49l2.393-2.393,2.393,2.393a.347.347,0,0,0,.49-.49l-2.392-2.393,2.393-2.392A.347.347,0,0,0,441.437,749.014Z",
  transform: "translate(-432.745 -746.089)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconError, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_error.7902fae3.svg";
export { ForwardRef as ReactComponent };